import MuncherMob from '../Mobs/MuncherMob'

export default class {
    constructor (game, startPosition, color) {
        this._game = game
        this._mob = new MuncherMob(startPosition, color)
        this._game.getWorld().add(this._mob)
    }

    getScore () {
        return this._mob.getTail().getSize()
    }
}
